import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import { I18N } from 'commons';
import FieldErrorMessage from "./FieldErrorMessage";

const DropDownWithLabel = ({ defaultValue, emptyOptionValue, label, name, field, onChange, disabled, list, shouldShowEmptyOptions, testSelector, mandatory, error, onBlur }) => {
  const [showEmptyOption, setShowEmptyOption] = useState(shouldShowEmptyOptions);
  const dropdownRef = useRef();
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (e) => {
    const value = dropdownRef.current?.value;
    if (value && !shouldShowEmptyOptions) {
      setShowEmptyOption(false);
    }
    setValue(value)
    onChange && onChange(e);
  };

  const getList = list => {
    if (!list.length) {
      return [];
    }
    return list.map(({ displayLabel, id }) => (
        <option value={id} key={id}>
          {displayLabel}
        </option>
    ));
  }
  return (
      <div className="form-group row">
        <div className="col-md-12">
          <label htmlFor={field}>
            <I18N>{label}</I18N>
            {mandatory && (
                <>
                  <span aria-hidden="true" className="required-star">*</span>
                  <span className="sr-only"><I18N>information.label.required</I18N></span>
                </>
            )}
          </label>
          <select
              id={field}
              ref={dropdownRef}
              className={`form-control ${error ? 'is-invalid' : ''}`}
              onChange={handleChange}
              onBlur={onBlur}
              name={name}
              defaultValue={defaultValue}
              disabled={disabled}
              required={mandatory}
              eb-test={testSelector}
              aria-invalid={!!error}
              value={value}
          >
            {
                showEmptyOption && ((emptyOptionValue && <option value={emptyOptionValue}>{emptyOptionValue}</option>) || <I18N tag="option">ssp.select.null.text</I18N>)
            }
            {getList(list)}
          </select>
          {error && (
              <FieldErrorMessage id="error" role="alert">
                <I18N>{error}</I18N>
              </FieldErrorMessage>
          )}
        </div>
      </div>
  );
};

DropDownWithLabel.propTypes = {
  defaultValue: PropTypes.string,
  name: PropTypes.string,
  shouldShowEmptyOptions: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.shape()),
  testSelector: PropTypes.string,
  mandatory: PropTypes.bool,
  error: PropTypes.string,
  onBlur: PropTypes.func,
  emptyOptionValue: PropTypes.string,
};

DropDownWithLabel.defaultProps = {
  defaultValue: '',
  list: [],
  disabled: false,
  shouldShowEmptyOptions: true,
  mandatory: false,
  testSelector: '',
  onChange: () => {},
  error: '',
  onBlur: () => {}
};

export default DropDownWithLabel;